import { useSetAtom } from 'jotai';
import { sellerAtom } from '../../atoms';

export const useSellerDataUpdater = () => {
    const setSellerData = useSetAtom(sellerAtom);

    return setSellerData;
};
